import { getApiKeys, getBillingApiRequestLogs } from '@repo/api-portal-sdk/gen'

const API_KEY_LIMIT = 200
const REQUEST_LOG_LIMIT = 50

export interface RequestLogsSearch {
	apiKeyId?: string
	route?: string
	method?: string
	statusClass?: '2xx' | '3xx' | '4xx' | '5xx'
	apiKeyStatus?: 'active' | 'expired' | 'revoked'
	from?: string
	to?: string
	cursor?: string
}

export async function loadRequestLogs(input: {
	search: RequestLogsSearch
	signal: AbortSignal
}) {
	const [keys, logs] = await Promise.all([
		getApiKeys({
			query: { limit: API_KEY_LIMIT },
			signal: input.signal
		}),
		getBillingApiRequestLogs({
			query: { ...input.search, limit: REQUEST_LOG_LIMIT },
			signal: input.signal
		})
	])

	return {
		keys: keys.data.data,
		logs: logs.data.data,
		meta: logs.data.meta
	}
}
